import { FC, ReactNode } from 'react';

interface ICustomTickProps {
  x?: number;
  y?: number;
  payload?: {
    value: number | string;
  };
  tickFormatter?: (value?: number | string) => ReactNode;
  isXAxis?: boolean;
  firstPaymentTime?: number;
}

export const CustomAxisTick: FC<ICustomTickProps> = ({
  x,
  y,
  payload,
  tickFormatter,
  isXAxis,
  firstPaymentTime,
}) => {
  let dy = 16;
  let dx = 0;

  if (isXAxis) {
    dx += 39;
    if (payload?.value === firstPaymentTime) {
      dx += 20;
    }
  } else {
    dy -= 14;
  }

  return (
    <text
      x={x}
      y={y}
      dx={dx}
      dy={dy}
      textAnchor="end"
      fill="var(--text-secondary)"
      fontSize={12}
    >
      {tickFormatter ? tickFormatter(payload?.value) : payload?.value}
    </text>
  );
};
